<!--
  Legal text is 12px/500 `#7b7b7b`, `leading-[16px]`, not italic — full content, no scroll.
  `<p class="m-0">`: the browser's own default `p` margin (and the `<br>` right after each one)
  otherwise stacks on top of the near-zero gap under the "I agree to the following"
  checkbox, pushing this text noticeably further down/apart than intended.
-->
<div class="font-medium text-[#7b7b7b] text-xs leading-4">
  @for (item of legalTextData().text; track $index) {
    <p class="m-0">
      @for (part of parseText(item); track $index) {
        @if (!isLink(part)) {
          {{ part }}
        } @else {
          <a [href]="part?.href" [target]="part?.target">{{ part?.text }}</a>
        }
      }
    </p>
    <br />
  }
</div>
